import axios from "axios";
import Bg1 from "../../assets/images/bgimage1.png";
import Bg2 from "../../assets/images/bgimage2.png";

import Calaneder from "../../assets/svg/desk.svg";
import { BASE_URL, IMAGE_URL } from "../../config/axios";
import React, { useState, useEffect } from "react";
import { formattedDate, formattedDateLong } from "../Date";
import { useNavigate } from "react-router-dom";
import { AnnouncementIllustration, BirthdayIcon, CelebrationIcon, OfficeBagIcon, PDFIcon, StarTrophyIllustration, Trophy, TrophyIconWithoutIllustration, WorkAnniversary } from "../AllSvg";
import { AttachmentIcon, CustomImageModal, handleErrorToast } from "../CustomFunctions";
import UserDefaultLogo from "../UserDetails/UserDefaultLogo";
import Loader from "../Loader";
import { ToastContainer } from "react-toastify";
import badges from "../../assets/images/badges.jpeg";


// Announcements Tab
// const Announcements = () => {
//     const [allannouncement, setAllannouncement] = useState([]);
//     const [buffer, setBuffering] = useState(true);
//     const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));

//     const getAnnouncement = async () => {
//         setBuffering(true); // Start Buffering
//         try {
//             const res = await axios.get(`${BASE_URL}/settings/infromtation/${toggleCompany}/`);
//             setAllannouncement(res.data);
//         } catch (err) {
//             console.error(err.message);
//             // handleErrorToast(err)
//         } finally {
//             setBuffering(false);// End Buffering
//         }
//     };

//     useEffect(() => {
//         getAnnouncement();
//     }, [toggleCompany]);

//     const createMarkup = (content) => {
//         const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
//         return {
//             __html: content.replace(linkRegex, (url) => {
//                 return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
//             }),
//         };
//     };


//     const currentUrl = window.location.href;
//     const urlParts = currentUrl.split('/');

//     const url = urlParts[2]

//     const url1 = `letterhead`

//     const description = " Your hard work and dedication has been recognized. Delighted to inform you of a well-deserved salary increment, reflecting our appreciation for your valuable contributions. Congratulations!"

//     const today = new Date();


//     return (
//         <>
//             <div className="dashcomp-bg-cards EmployeeDashboad-notification-cards" style={{ height: '284px' }}>


//                 {
//                     buffer ?
//                         <Loader container={true} />
//                         :
//                         allannouncement.length === 0 ?
//                             'No Announcements at the moment...'
//                             :
//                             allannouncement
//                                 .filter(
//                                     (info) => info.start_visibility <= formattedDate && formattedDate <= info.end_visibility
//                                 )
//                                 ?.map((data, index) => {
//                                     const formattedDate = new Date(data.date).toLocaleString('en-US', {
//                                         month: 'long',
//                                         day: 'numeric',
//                                         year: 'numeric',
//                                     });
//                                     return (
//                                         <>
//                                             <div className="EmployeeDashboad-notification-card">
//                                                 <h3 className='dashcomp-announcement-heading font-weight500  font-size-subheading  '>{index + 1}.{"  "}{data.title}</h3>
//                                                 {/* <h3 className='dashcomp-announcement-heading font-weight500  font-size-subheading  '>{(sessionStorage.getItem("letter_type") == "None") ? (index + 1) : (index + 2)}.{"  "}{data.title}</h3> */}
//                                                 <span className="dashcomp-announcement-date  font-weight500 font-size-subheading  ">
//                                                     <img src={Calaneder} alt="Desk Icon"
//                                                         style={{
//                                                             color: 'red', marginRight: '8px',
//                                                             width: '16px', height: '16px', marginTop: "-4px"
//                                                         }}
//                                                     />
//                                                     {formattedDate}
//                                                 </span>
//                                                 <p className="dashcomp-announcement-p font-weight400  font-size-text">
//                                                     <div dangerouslySetInnerHTML={createMarkup(data.description)} />
//                                                 </p>

//                                                 {data.file ?
//                                                     <a href={data.file} target="_blank" rel="noreferrer">
//                                                         <AttachmentIcon source={data.file} />
//                                                     </a>
//                                                     : null}
//                                             </div>
//                                         </>
//                                     )
//                                 })
//                 }
//             </div>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </>
//     )
// }

// Birthday Tab
// const Birthday = () => {

//     const [todayBirthdays, setTodayBirthdays] = useState([]);
//     const [thisWeekBirthdays, setThisWeekBirthdays] = useState([]);
//     const [thisMonthBirthdays, setThisMonthBirthdays] = useState([]);
//     const [buffer, setBuffering] = useState(true);

//     const getBirthdayData = async () => {
//         setBuffering(true); // Start Buffering
//         try {
//             const res = await axios.get(`${BASE_URL}/settings/birthday/`);
//             filterBirthdays(res.data);
//         } catch (err) {
//             console.error(err.message);
//             // handleErrorToast(err)
//         } finally {
//             setBuffering(false);// End Buffering
//         }
//     };

//     useEffect(() => {
//         getBirthdayData();
//     }, []);

//     const getRandomBackgroundImage = () => {
//         const backgrounds = [`url("https://civilmantra.s3.ap-south-1.amazonaws.com/Gold+White+Modern+Happy+Birthday+Your+Story.png")`, `url(${Bg2})`];
//         const randomIndex = Math.floor(Math.random() * backgrounds.length);
//         return backgrounds[randomIndex];
//     };


//     const filterBirthdays = (data) => {
//         const today = new Date();
//         const thisWeekEnd = new Date();
//         thisWeekEnd.setDate(today.getDate() + 7);

//         const todayBirthdays = data.filter((item) => {
//             const dob = new Date(item.dob);
//             return dob.getDate() === today.getDate() && dob.getMonth() === today.getMonth();
//         });

//         const thisWeekBirthdays = data.filter((item) => {
//             const dob = new Date(item.dob);

//             const dobThisYear = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());

//             return dobThisYear >= today && dobThisYear <= thisWeekEnd;
//         });

//         const thisMonthBirthdays = data.filter((item) => {
//             const dob = new Date(item.dob);
//             const dobThisYear = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());

//             return dobThisYear > thisWeekEnd && dob.getMonth() === today.getMonth();
//         });

//         setTodayBirthdays(todayBirthdays);
//         setThisWeekBirthdays(thisWeekBirthdays);
//         setThisMonthBirthdays(thisMonthBirthdays);
//     };

//     return (
//         <>
//             <div className="EmployeeDashboad-notification-cards" style={{ height: '284px', overflowY: 'auto' }}>
//                 {buffer ? <Loader container={true} /> : null}
//                 {/* TODAY's BIRTHDAY */}
//                 {todayBirthdays.length > 0 && (
//                     <>
//                         <h2 className='font-size-heading'>Birthdays Today</h2>

//                         <div className='birthdaywrap'>
//                             {todayBirthdays.map((data, index) => {
//                                 const formattedEndDate = new Date(data.dob).toLocaleString('en-US', {
//                                     month: 'short',
//                                     day: 'numeric',
//                                     // year: 'numeric',
//                                 });

//                                 const randomBackground = getRandomBackgroundImage();

//                                 return (
//                                     <>
//                                         <div className="birthdaywrap-card">

//                                             <div key={index} className="dashcomp-bg-card-special">
//                                                 <div className="new-flex">
//                                                     <CustomImageModal customStyle>
//                                                         {data.profilepic ? (
//                                                             <img
//                                                                 src={`${`${IMAGE_URL}${data.profilepic}`}`}
//                                                                 alt="profile" className='dashcomp-image width-5vw'
//                                                             />
//                                                         ) : (
//                                                             <UserDefaultLogo user={{ name: data.name, profilepic: data.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile-dashboard'} />
//                                                         )}
//                                                     </CustomImageModal>

//                                                     <div>
//                                                         <h3 className='dashcomp-announcement-heading my-5px font-weight500  font-size-subheading  ' >{data.name}</h3>
//                                                         <span className="dashcomp-announcement-date  font-weight500 font-size-subheading  ">
//                                                             <img src={Calaneder} alt="Desk Icon" style={{
//                                                                 color: 'red',
//                                                                 marginRight: '8px', width: '16px', height: '16px', marginTop: "-4px"
//                                                             }}
//                                                             />
//                                                             {formattedEndDate}
//                                                         </span>
//                                                         <div className='new-flex'>
//                                                             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                                 <path d="M7.5 7H10.25M7.5 11H10.25M7.5 15H10.25M13.75 7H16.5M13.75 11H16.5M13.75 15H16.5M20 21V6.2C20 5.0799 20 4.51984 19.782 4.09202C19.5903 3.71569 19.2843 3.40973 18.908 3.21799C18.4802 3 17.9201 3 16.8 3H7.2C6.07989 3 5.51984 3 5.09202 3.21799C4.71569 3.40973 4.40973 3.71569 4.21799 4.09202C4 4.51984 4 5.0799 4 6.2V21M22 21H2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                                                             </svg>
//                                                             <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.division_name}</p>
//                                                         </div>

//                                                         <div className='new-flex'>
//                                                             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                                 <path d="M16 7C16 6.07003 16 5.60504 15.8978 5.22354C15.6204 4.18827 14.8117 3.37962 13.7765 3.10222C13.395 3 12.93 3 12 3C11.07 3 10.605 3 10.2235 3.10222C9.18827 3.37962 8.37962 4.18827 8.10222 5.22354C8 5.60504 8 6.07003 8 7M5.2 21H18.8C19.9201 21 20.4802 21 20.908 20.782C21.2843 20.5903 21.5903 20.2843 21.782 19.908C22 19.4802 22 18.9201 22 17.8V10.2C22 9.07989 22 8.51984 21.782 8.09202C21.5903 7.71569 21.2843 7.40973 20.908 7.21799C20.4802 7 19.9201 7 18.8 7H5.2C4.07989 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2V17.8C2 18.9201 2 19.4802 2.21799 19.908C2.40973 20.2843 2.71569 20.5903 3.09202 20.782C3.51984 21 4.0799 21 5.2 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                                                             </svg>
//                                                             <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.department_name}</p>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <br />
//                                             </div>
//                                         </div>

//                                     </>
//                                 );
//                             })}
//                         </div>
//                     </>
//                 )}

//                 {/* WEEK BIRTHDAY */}
//                 {thisWeekBirthdays.length > 0 && (
//                     <>
//                         <h2 className='font-size-heading mt-2'>Birthdays This Week</h2>

//                         <div className='birthdaywrap'>
//                             {thisWeekBirthdays.map((data, index) => {

//                                 const formattedEndDate = new Date(data.dob).toLocaleString('en-US', {
//                                     month: 'short',
//                                     day: 'numeric',
//                                     // year: 'numeric',
//                                 });

//                                 const randomBackground = getRandomBackgroundImage();

//                                 return (
//                                     <>
//                                         <div className="birthdaywrap-card">

//                                             <div key={index} className="dashcomp-bg-card-special">
//                                                 <div className="new-flex">
//                                                     <CustomImageModal customStyle>
//                                                         {data.profilepic ? (
//                                                             <img
//                                                                 src={`${`${IMAGE_URL}${data.profilepic}`}`}
//                                                                 alt="profile" className='dashcomp-image width-5vw'
//                                                             />
//                                                         ) : (
//                                                             <UserDefaultLogo user={{ name: data.name, profilepic: data.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile-dashboard'} />
//                                                         )}
//                                                     </CustomImageModal>
//                                                     <div>
//                                                         <h3 className='dashcomp-announcement-heading font-weight500 my-5px  font-size-subheading  ' >{data.name}</h3>
//                                                         <span className="dashcomp-announcement-date  font-weight500 font-size-subheading  ">
//                                                             <img src={Calaneder} alt="Desk Icon" style={{
//                                                                 color: 'red',
//                                                                 marginRight: '8px', width: '16px', height: '16px', marginTop: "-4px"
//                                                             }}
//                                                             />
//                                                             {formattedEndDate}
//                                                         </span>
//                                                         <div className='new-flex'>
//                                                             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                                 <path d="M7.5 7H10.25M7.5 11H10.25M7.5 15H10.25M13.75 7H16.5M13.75 11H16.5M13.75 15H16.5M20 21V6.2C20 5.0799 20 4.51984 19.782 4.09202C19.5903 3.71569 19.2843 3.40973 18.908 3.21799C18.4802 3 17.9201 3 16.8 3H7.2C6.07989 3 5.51984 3 5.09202 3.21799C4.71569 3.40973 4.40973 3.71569 4.21799 4.09202C4 4.51984 4 5.0799 4 6.2V21M22 21H2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                                                             </svg>
//                                                             <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.division_name}</p>
//                                                         </div>

//                                                         <div className='new-flex'>
//                                                             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                                 <path d="M16 7C16 6.07003 16 5.60504 15.8978 5.22354C15.6204 4.18827 14.8117 3.37962 13.7765 3.10222C13.395 3 12.93 3 12 3C11.07 3 10.605 3 10.2235 3.10222C9.18827 3.37962 8.37962 4.18827 8.10222 5.22354C8 5.60504 8 6.07003 8 7M5.2 21H18.8C19.9201 21 20.4802 21 20.908 20.782C21.2843 20.5903 21.5903 20.2843 21.782 19.908C22 19.4802 22 18.9201 22 17.8V10.2C22 9.07989 22 8.51984 21.782 8.09202C21.5903 7.71569 21.2843 7.40973 20.908 7.21799C20.4802 7 19.9201 7 18.8 7H5.2C4.07989 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2V17.8C2 18.9201 2 19.4802 2.21799 19.908C2.40973 20.2843 2.71569 20.5903 3.09202 20.782C3.51984 21 4.0799 21 5.2 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                                                             </svg>
//                                                             <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.department_name}</p>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <br />
//                                             </div>
//                                         </div>
//                                     </>
//                                 );
//                             })}
//                         </div>
//                     </>
//                 )}

//                 {/* MONTH BIRTHDAY */}
//                 {thisMonthBirthdays.length > 0 && (
//                     <>
//                         <h2 className='font-size-heading mt-2'>Birthdays This Month</h2>

//                         <div className='birthdaywrap'>
//                             {thisMonthBirthdays.map((data, index) => {
//                                 const formattedEndDate = new Date(data.dob).toLocaleString('en-US', {
//                                     month: 'short',
//                                     day: 'numeric',
//                                     year: 'numeric',
//                                 });
//                                 const randomBackground = getRandomBackgroundImage();
//                                 return (
//                                     <>
//                                         <div className="birthdaywrap-card">


//                                             <div key={index} className="dashcomp-bg-card-special">
//                                                 <div className="new-flex">
//                                                     <CustomImageModal customStyle>
//                                                         {data.profilepic ? (
//                                                             <img
//                                                                 src={`${`${IMAGE_URL}${data.profilepic}`}`}
//                                                                 alt="profile" className='dashcomp-image width-5vw'
//                                                             />
//                                                         ) : (
//                                                             <UserDefaultLogo user={{ name: data.name, profilepic: data.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile-dashboard'} />
//                                                         )}
//                                                     </CustomImageModal>
//                                                     <div>
//                                                         <h3 className='dashcomp-announcement-heading my-5px font-weight500  font-size-subheading  ' >{data.name}</h3>
//                                                         <span className="dashcomp-announcement-date  font-weight500 font-size-subheading  ">
//                                                             <img src={Calaneder} alt="Desk Icon" style={{
//                                                                 color: 'red',
//                                                                 marginRight: '8px', width: '16px', height: '16px', marginTop: "-4px"
//                                                             }}
//                                                             />
//                                                             {formattedEndDate}
//                                                         </span>
//                                                         <div className='new-flex'>
//                                                             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                                 <path d="M7.5 7H10.25M7.5 11H10.25M7.5 15H10.25M13.75 7H16.5M13.75 11H16.5M13.75 15H16.5M20 21V6.2C20 5.0799 20 4.51984 19.782 4.09202C19.5903 3.71569 19.2843 3.40973 18.908 3.21799C18.4802 3 17.9201 3 16.8 3H7.2C6.07989 3 5.51984 3 5.09202 3.21799C4.71569 3.40973 4.40973 3.71569 4.21799 4.09202C4 4.51984 4 5.0799 4 6.2V21M22 21H2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                                                             </svg>
//                                                             <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.division_name}</p>
//                                                         </div>

//                                                         <div className='new-flex'>
//                                                             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                                 <path d="M16 7C16 6.07003 16 5.60504 15.8978 5.22354C15.6204 4.18827 14.8117 3.37962 13.7765 3.10222C13.395 3 12.93 3 12 3C11.07 3 10.605 3 10.2235 3.10222C9.18827 3.37962 8.37962 4.18827 8.10222 5.22354C8 5.60504 8 6.07003 8 7M5.2 21H18.8C19.9201 21 20.4802 21 20.908 20.782C21.2843 20.5903 21.5903 20.2843 21.782 19.908C22 19.4802 22 18.9201 22 17.8V10.2C22 9.07989 22 8.51984 21.782 8.09202C21.5903 7.71569 21.2843 7.40973 20.908 7.21799C20.4802 7 19.9201 7 18.8 7H5.2C4.07989 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2V17.8C2 18.9201 2 19.4802 2.21799 19.908C2.40973 20.2843 2.71569 20.5903 3.09202 20.782C3.51984 21 4.0799 21 5.2 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                                                             </svg>
//                                                             <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.department_name}</p>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <br />
//                                             </div>
//                                         </div>
//                                     </>
//                                 );
//                             })}
//                         </div>
//                     </>
//                 )}
//             </div>
//             <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//         </>
//     );
// };


// Workanniversery Tab
// const Workanniversery = () => {
//     const [todayAnniversaries, setTodayAnniversaries] = useState([]);
//     const [thisWeekAnniversaries, setThisWeekAnniversaries] = useState([]);
//     const [thisMonthAnniversaries, setThisMonthAnniversaries] = useState([]);
//     const [buffer, setBuffering] = useState(true);

//     const getBirthdayData = async () => {
//         setBuffering(true); // Start Buffering
//         try {
//             const res = await axios.get(`${BASE_URL}/settings/workaniversary/`);
//             filterWorkanniversery(res.data);
//         } catch (err) {
//             console.error(err.message);
//         } finally {
//             setBuffering(false);// End Buffering
//         }
//     };

//     useEffect(() => {
//         getBirthdayData();
//     }, []);

//     const getRandomBackgroundImage = () => {
//         const backgrounds = [`url("https://civilmantra.s3.ap-south-1.amazonaws.com/Gold+White+Modern+Happy+Birthday+Your+Story.png")`, `url(${Bg2})`];
//         const randomIndex = Math.floor(Math.random() * backgrounds.length);
//         return backgrounds[randomIndex];
//     };

//     const filterWorkanniversery = (data) => {
//         const today = new Date();
//         const thisWeekEnd = new Date();
//         // const thisWeekEndd = new Date();
//         // const thisMonthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);

//         thisWeekEnd.setDate(today.getDate() + 7);
//         // thisWeekEndd.setDate(today.getDate() + 8);

//         const todayAnniversaries = data.filter((item) => {
//             const joining_date = new Date(item.joining_date);
//             return joining_date.getDate() === today.getDate() && joining_date.getMonth() === today.getMonth();
//         });

//         const thisWeekWorkAnniversary = data.filter((item) => {
//             const joining_date = new Date(item.joining_date);


//             const weeklyworkAnnThisYear = new Date(today.getFullYear(), joining_date.getMonth(), joining_date.getDate());

//             return weeklyworkAnnThisYear >= today && weeklyworkAnnThisYear <= thisWeekEnd;
//         });

//         const thisMonthWorkAnniversary = data.filter((item) => {
//             const joining_date = new Date(item.joining_date);

//             const monthlyworkAnnThisYear = new Date(today.getFullYear(), joining_date.getMonth(), joining_date.getDate());

//             return monthlyworkAnnThisYear > thisWeekEnd && joining_date.getMonth() === today.getMonth();
//         });

//         setTodayAnniversaries(todayAnniversaries);
//         setThisWeekAnniversaries(thisWeekWorkAnniversary);
//         setThisMonthAnniversaries(thisMonthWorkAnniversary);
//     };

//     // calculate years
//     // const [anniversaryDate, setanniversaryDate] = useState(new Date('1990-01-01'));
//     const calculateAnniversary = (anniversaryDate) => {
//         const currentDate = new Date();
//         const startYear = anniversaryDate.getFullYear();
//         const currentYear = currentDate.getFullYear();
//         const workYears = currentYear - startYear;
//         return workYears;
//     };


//     return (
//         <div className="dashcomp-bg-cards EmployeeDashboad-notification-cards " style={{ height: '284px' }}>
//             {buffer ? <Loader container={true} /> : null}
//             {/* TODAY's BIRTHDAY */}
//             {todayAnniversaries.length > 0 && (
//                 <>
//                     <h2 className=' font-size-heading'>Anniversaries Today</h2>

//                     <div className='birthdaywrap'>
//                         {todayAnniversaries.map((data, index) => {
//                             const formattedEndDate = new Date(data.joining_date).toLocaleString('en-US', {
//                                 month: 'short',
//                                 day: 'numeric',
//                                 year: 'numeric',
//                             });
//                             const randomBackground = getRandomBackgroundImage();

//                             return (
//                                 <>
//                                     <div className="birthdaywrap-card">

//                                         <div key={index} className="dashcomp-bg-card-special">
//                                             <div className="new-flex">
//                                                 <CustomImageModal customStyle>
//                                                     {data.profilepic ? (
//                                                         <img
//                                                             src={`${`${IMAGE_URL}${data.profilepic}`}`}
//                                                             alt="profile" className='dashcomp-image width-5vw'
//                                                         />
//                                                     ) : (
//                                                         <UserDefaultLogo user={{ name: data.name, profilepic: data.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile-dashboard'} />
//                                                     )}
//                                                 </CustomImageModal>
//                                                 <div>
//                                                     <h3 className='dashcomp-announcement-heading my-5px font-weight500  font-size-subheading  ' >{data.name}</h3>
//                                                     <span className="dashcomp-announcement-date  font-weight500 font-size-subheading  ">
//                                                         <img src={Calaneder} alt="Desk Icon" style={{
//                                                             color: 'red',
//                                                             marginRight: '8px', width: '16px', height: '16px', marginTop: "-4px"
//                                                         }}
//                                                         />
//                                                         {/* {calculateAnniversary(formattedEndDate)} */}
//                                                         {calculateAnniversary(new Date(data.joining_date))} yrs

//                                                     </span>
//                                                     <div className='new-flex'>
//                                                         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                             <path d="M7.5 7H10.25M7.5 11H10.25M7.5 15H10.25M13.75 7H16.5M13.75 11H16.5M13.75 15H16.5M20 21V6.2C20 5.0799 20 4.51984 19.782 4.09202C19.5903 3.71569 19.2843 3.40973 18.908 3.21799C18.4802 3 17.9201 3 16.8 3H7.2C6.07989 3 5.51984 3 5.09202 3.21799C4.71569 3.40973 4.40973 3.71569 4.21799 4.09202C4 4.51984 4 5.0799 4 6.2V21M22 21H2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                                                         </svg>
//                                                         <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.division_name}</p>
//                                                     </div>

//                                                     <div className='new-flex'>
//                                                         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                             <path d="M16 7C16 6.07003 16 5.60504 15.8978 5.22354C15.6204 4.18827 14.8117 3.37962 13.7765 3.10222C13.395 3 12.93 3 12 3C11.07 3 10.605 3 10.2235 3.10222C9.18827 3.37962 8.37962 4.18827 8.10222 5.22354C8 5.60504 8 6.07003 8 7M5.2 21H18.8C19.9201 21 20.4802 21 20.908 20.782C21.2843 20.5903 21.5903 20.2843 21.782 19.908C22 19.4802 22 18.9201 22 17.8V10.2C22 9.07989 22 8.51984 21.782 8.09202C21.5903 7.71569 21.2843 7.40973 20.908 7.21799C20.4802 7 19.9201 7 18.8 7H5.2C4.07989 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2V17.8C2 18.9201 2 19.4802 2.21799 19.908C2.40973 20.2843 2.71569 20.5903 3.09202 20.782C3.51984 21 4.0799 21 5.2 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                                                         </svg>
//                                                         <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.department_name}</p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <br />
//                                             <br />
//                                             {/* <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.designation_name}</p> */}
//                                         </div>
//                                     </div>
//                                 </>
//                             );
//                         })}
//                     </div>
//                 </>
//             )}

//             {/* WEEK BIRTHDAY */}
//             {thisWeekAnniversaries.length > 0 && (
//                 <>
//                     <h2 className='font-size-heading mt-2'>Anniversaries This Week</h2>

//                     <div className='birthdaywrap'>
//                         {thisWeekAnniversaries.map((data, index) => {

//                             const formattedEndDate = new Date(data.joining_date).toLocaleString('en-US', {
//                                 month: 'short',
//                                 day: 'numeric',
//                                 year: 'numeric',
//                             });

//                             const randomBackground = getRandomBackgroundImage();

//                             return (
//                                 <>
//                                     <div className="birthdaywrap-card">

//                                         <div key={index} className="dashcomp-bg-card-special">
//                                             <div className="new-flex">
//                                                 <CustomImageModal customStyle>
//                                                     {data.profilepic ? (
//                                                         <img
//                                                             src={`${`${IMAGE_URL}${data.profilepic}`}`}
//                                                             alt="profile" className='dashcomp-image width-5vw'
//                                                         />
//                                                     ) : (
//                                                         <UserDefaultLogo user={{ name: data.name, profilepic: data.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile-dashboard'} />
//                                                     )}
//                                                 </CustomImageModal>
//                                                 <div>
//                                                     <h3 className='dashcomp-announcement-heading my-5px font-weight500  font-size-subheading  ' >{data.name}</h3>
//                                                     <span className="dashcomp-announcement-date  font-weight500 font-size-subheading  ">
//                                                         <img src={Calaneder} alt="Desk Icon" style={{
//                                                             color: 'red',
//                                                             marginRight: '8px', width: '16px', height: '16px', marginTop: "-4px"
//                                                         }}
//                                                         />
//                                                         {/* {calculateAnniversary(formattedEndDate)} */}
//                                                         {calculateAnniversary(new Date(data.joining_date))} yrs

//                                                     </span>
//                                                     <div className='new-flex'>
//                                                         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                             <path d="M7.5 7H10.25M7.5 11H10.25M7.5 15H10.25M13.75 7H16.5M13.75 11H16.5M13.75 15H16.5M20 21V6.2C20 5.0799 20 4.51984 19.782 4.09202C19.5903 3.71569 19.2843 3.40973 18.908 3.21799C18.4802 3 17.9201 3 16.8 3H7.2C6.07989 3 5.51984 3 5.09202 3.21799C4.71569 3.40973 4.40973 3.71569 4.21799 4.09202C4 4.51984 4 5.0799 4 6.2V21M22 21H2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                                                         </svg>
//                                                         <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.division_name}</p>
//                                                     </div>

//                                                     <div className='new-flex'>
//                                                         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                             <path d="M16 7C16 6.07003 16 5.60504 15.8978 5.22354C15.6204 4.18827 14.8117 3.37962 13.7765 3.10222C13.395 3 12.93 3 12 3C11.07 3 10.605 3 10.2235 3.10222C9.18827 3.37962 8.37962 4.18827 8.10222 5.22354C8 5.60504 8 6.07003 8 7M5.2 21H18.8C19.9201 21 20.4802 21 20.908 20.782C21.2843 20.5903 21.5903 20.2843 21.782 19.908C22 19.4802 22 18.9201 22 17.8V10.2C22 9.07989 22 8.51984 21.782 8.09202C21.5903 7.71569 21.2843 7.40973 20.908 7.21799C20.4802 7 19.9201 7 18.8 7H5.2C4.07989 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2V17.8C2 18.9201 2 19.4802 2.21799 19.908C2.40973 20.2843 2.71569 20.5903 3.09202 20.782C3.51984 21 4.0799 21 5.2 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                                                         </svg>
//                                                         <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.department_name}</p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <br />

//                                             <br />
//                                             {/* <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.designation_name}</p> */}
//                                         </div>
//                                     </div>
//                                 </>
//                             );
//                         })}
//                     </div>
//                 </>
//             )}

//             {/* MONTH BIRTHDAY */}
//             {thisMonthAnniversaries.length > 0 && (
//                 <>
//                     <h2 className='font-size-heading mt-2'>Anniversaries This Month</h2>

//                     <div className='birthdaywrap'>
//                         {thisMonthAnniversaries.map((data, index) => {
//                             const formattedEndDate = new Date(data.joining_date).toLocaleString('en-US', {
//                                 month: 'short',
//                                 day: 'numeric',
//                                 year: 'numeric',
//                             });
//                             const randomBackground = getRandomBackgroundImage();
//                             return (
//                                 <>
//                                     <div className="birthdaywrap-card">


//                                         <div key={index} className="dashcomp-bg-card-special">
//                                             <div className="new-flex">
//                                                 <CustomImageModal customStyle>
//                                                     {data.profilepic ? (
//                                                         <img
//                                                             src={`${`${IMAGE_URL}${data.profilepic}`}`}
//                                                             alt="profile" className='dashcomp-image width-5vw'
//                                                         />
//                                                     ) : (
//                                                         <UserDefaultLogo user={{ name: data.name, profilepic: data.profilepic }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'small-profile-dashboard'} />
//                                                     )}
//                                                 </CustomImageModal>
//                                                 <div>
//                                                     <h3 className='dashcomp-announcement-heading my-5px font-weight500  font-size-subheading  ' >{data.name}</h3>
//                                                     <span className="dashcomp-announcement-date  font-weight500 font-size-subheading  ">
//                                                         <img src={Calaneder} alt="Desk Icon" style={{
//                                                             color: 'red',
//                                                             marginRight: '8px', width: '16px', height: '16px', marginTop: "-4px"
//                                                         }}
//                                                         />
//                                                         {/* {calculateAnniversary(formattedEndDate)} */}
//                                                         {calculateAnniversary(new Date(data.joining_date))} yrs

//                                                     </span>
//                                                     <div className='new-flex'>
//                                                         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                             <path d="M7.5 7H10.25M7.5 11H10.25M7.5 15H10.25M13.75 7H16.5M13.75 11H16.5M13.75 15H16.5M20 21V6.2C20 5.0799 20 4.51984 19.782 4.09202C19.5903 3.71569 19.2843 3.40973 18.908 3.21799C18.4802 3 17.9201 3 16.8 3H7.2C6.07989 3 5.51984 3 5.09202 3.21799C4.71569 3.40973 4.40973 3.71569 4.21799 4.09202C4 4.51984 4 5.0799 4 6.2V21M22 21H2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                                                         </svg>
//                                                         <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.division_name}</p>
//                                                     </div>

//                                                     <div className='new-flex'>
//                                                         <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
//                                                             <path d="M16 7C16 6.07003 16 5.60504 15.8978 5.22354C15.6204 4.18827 14.8117 3.37962 13.7765 3.10222C13.395 3 12.93 3 12 3C11.07 3 10.605 3 10.2235 3.10222C9.18827 3.37962 8.37962 4.18827 8.10222 5.22354C8 5.60504 8 6.07003 8 7M5.2 21H18.8C19.9201 21 20.4802 21 20.908 20.782C21.2843 20.5903 21.5903 20.2843 21.782 19.908C22 19.4802 22 18.9201 22 17.8V10.2C22 9.07989 22 8.51984 21.782 8.09202C21.5903 7.71569 21.2843 7.40973 20.908 7.21799C20.4802 7 19.9201 7 18.8 7H5.2C4.07989 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.07989 2 10.2V17.8C2 18.9201 2 19.4802 2.21799 19.908C2.40973 20.2843 2.71569 20.5903 3.09202 20.782C3.51984 21 4.0799 21 5.2 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
//                                                         </svg>
//                                                         <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.department_name}</p>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                             <br />

//                                             <br />
//                                             {/* <p className="dashcomp-announcement-p font-weight400  font-size-text">{data.designation_name}</p> */}
//                                         </div>
//                                     </div>
//                                 </>
//                             );
//                         })}
//                     </div>
//                 </>
//             )}
//         </div>
//     );
// }


// ImportantMessage Tab
// const ImportantMessage = () => {

//     const [message, setImpoMessage] = useState([]);
//     // const [selectedImage, setSelectedImage] = useState('');

//     useEffect(() => {
//         const getImportantInfoData = async () => {
//             try {
//                 const res = await axios.get(`${BASE_URL}/settings/importantnotificationAPI/`);
//                 setImpoMessage(res.data);
//             } catch (err) {
//                 console.error(err.message);
//             }
//         };
//         getImportantInfoData();
//     }, []);
//     const createMarkup = (content) => {
//         const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
//         return {
//             __html: content.replace(linkRegex, (url) => {
//                 return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
//             }),
//         };
//     };

//     return (
//         <>
//             <div className='birthdaywrap EmployeeDashboad-notification-cards' style={{ height: '284px' }}>
//                 {message.map((data, index) => {

//                     console.log(data)
//                     const formattedEndDate = new Date(data.date).toLocaleString('en-US', {
//                         month: 'short',
//                         day: 'numeric',
//                         year: 'numeric',
//                     });


//                     return (
//                         <>

//                             <div key={index} className="dashcomp-bg-card ">


//                                 <p className="dashcomp-announcement-p font-weight400  font-size-text">
//                                     {/* {index + 1}.  */}
//                                     <div dangerouslySetInnerHTML={createMarkup((index + 1) + ". " + data.message)} />
//                                 </p>
//                                 <span className="dashcomp-announcement-date  font-weight500 font-size-subheading  ">

//                                     <img src={Calaneder} alt="Desk Icon" style={{
//                                         color: 'red',
//                                         marginRight: '8px', width: '16px', height: '16px', marginTop: "-4px"
//                                     }}
//                                     />
//                                     {formattedEndDate}

//                                 </span>
//                                 <br />
//                                 <br />

//                                 <p style={{ borderBottom: '2px solid grey' }} />
//                             </div>
//                         </>
//                     );
//                 })}
//             </div>
//         </>
//     )
// }


// Event Tab
// const Event = () => {

//     const [event, setEvent] = useState([]);
//     const [buffer, setBuffering] = useState(true);
//     // const [selectedImage, setSelectedImage] = useState('');
//     const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
//     useEffect(() => {
//         const getEventData = async () => {
//             setBuffering(true);
//             try {
//                 const res = await axios.get(`${BASE_URL}/settings/event-filter/${toggleCompany}/`);
//                 setEvent(res.data);
//             } catch (err) {
//                 console.error(err.message);
//             }
//             finally {
//                 setBuffering(false);
//             }
//         };
//         getEventData();
//     }, [toggleCompany]);

//     const createMarkup = (content) => {
//         const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
//         return {
//             __html: content.replace(linkRegex, (url) => {
//                 return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
//             }),
//         };
//     };

//     return (
//         <>
//             <div className='event-bg-cards  EmployeeDashboad-notification-cards ' style={{ height: '284px' }}>
//                 {buffer ? <Loader container={true} /> : null}
//                 {event.map((data, index) => {

//                     const formattedEndDate = new Date(data.date).toLocaleString('en-US', {
//                         month: 'short',
//                         day: 'numeric',
//                         year: 'numeric',
//                     });

//                     return (
//                         <>
//                             <div className="birthdaywrap-card" style={{ width: '94%' }}>
//                                 <div key={index} className="dashcomp-bg-card-special gap-2">
//                                     <div className="event-img-card" style={{ width: '19%' }}>
//                                         <CustomImageModal customStyle>
//                                             {data.file ? (
//                                                 <img
//                                                     src={`${data.file}`}
//                                                     alt={data.title} className='event-img'
//                                                 />
//                                             ) : ('')
//                                             }
//                                         </CustomImageModal>
//                                     </div>
//                                     <span className="vertical-right-border"></span>
//                                     <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
//                                         <span style={{ flex: 1, fontSize: '14px' }} className="dashcomp-announcement-date  font-weight500 font-size-subheading  ">


//                                             {formattedEndDate}
//                                         </span>

//                                         <div>
//                                             <h3 style={{ flex: 3, fontSize: '19px' }} className='dashcomp-announcement-heading font-weight500  font-size-subheading  ' >{data.title}</h3>
//                                             <p className="dashcomp-announcement-p font-weight400  font-size-text">
//                                                 <div dangerouslySetInnerHTML={createMarkup(data.description)} />
//                                             </p>
//                                         </div>
//                                     </div>


//                                 </div>
//                             </div>
//                         </>
//                     );
//                 })}
//             </div>
//         </>
//     )
// }


// Star Tab
// const Star = () => {

//     const [star, setStar] = useState([]);
//     const [buffer, setBuffering] = useState(true);
//     const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));
//     // const [selectedImage, setSelectedImage] = useState('');

//     useEffect(() => {
//         setBuffering(true);
//         const getStarData = async () => {
//             try {
//                 const res = await axios.get(`${BASE_URL}/wfm/performance-by-filter/${toggleCompany}/`);
//                 setStar(res.data);
//             } catch (err) {
//                 console.error(err.message);
//                 // handleErrorToast(err)
//             }
//             finally {
//                 setBuffering(false);
//             }
//         };
//         getStarData();
//     }, [toggleCompany]);


//     return (
//         <>
//             <div className="flex justify-between gap-2">
//                 {buffer ? <Loader container={true} /> : null}
//                 {star.map((data, index) => {
//                     return (
//                         <>

//                             <div className='dashcomp-bg-cards EmployeeDashboad-notification-cards dashboard-card-dimensions' >
//                                 <div className="awards-card award-card-container awards-card-margin"
//                                 >
//                                     <span className="profile-absolute-position">
//                                         <CustomImageModal customStyle>
//                                             {data.profilepic ? (
//                                                 <img
//                                                     src={`${`${IMAGE_URL}${data.profilepic}`}`}
//                                                     style={{ borderRadius: "50%", border: "2px solid #dce3f0" }}
//                                                     alt="profile" className="performance-profile-img"
//                                                 />
//                                             ) : (
//                                                 <UserDefaultLogo user={{ name: data.name, profilepic: '' }} customStyleforParent={"reqOutDuty-default-logo-dashboard"} customStyleforChild={'star-profile-dashboard'} />
//                                             )}
//                                         </CustomImageModal>
//                                     </span>

//                                     <div className="primary-subcard primary-subcard-outer flex flex-column primary-subcard-position"  >
//                                         {/* <img src={`${IMAGE_URL}${data.profilepic}`} alt="Profile" className="performance-profile-img  width-5vw" /> */}

//                                         {/* <div className="secondary-subcard w-full"> */}
//                                         <div className="top-details flex flex-column w-full" >

//                                             <div className="award-title" ><span className="award-title-text font-size-text" >{data.title}</span> has been awarded by </div>
//                                             <span className="award-title-text">{data.recognized_by}</span>
//                                             <span className="reason-text"> for completing your {data.reason_for_recogntion}</span>

//                                         </div>
//                                         <div className="flex flex-column w-full star-reward-back">
//                                             <span className="congrats-styling">
//                                                 Congratulations
//                                             </span>
//                                             <span className="text-center award-title-text">{data.title}</span>
//                                             <div className="flex item-center justify-center">
//                                                 <CustomImageModal customStyle>
//                                                     <img src={data.image_reward} alt="Badge" className="performance-reward-img  performance-reward-img-s" />
//                                                 </CustomImageModal>
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div >
//                             </div>
//                         </>
//                     );
//                 })}
//             </div>
//         </>
//     )
// }

// const Informationcomponent = () => {

//     const [toggleState, setToggleState] = useState(1);
//     return (
//         <div className='backgroundmain'>
//             <div className='dashboardcomponent box-width '>
//                 <div >
//                     <div className="bloc-tabs">
//                         <button
//                             className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "}
//                             onClick={() => setToggleState(1)}
//                         >
//                             Announcements
//                         </button>
//                         <button
//                             className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "}
//                             onClick={() => setToggleState(2)}
//                         >
//                             Birthday
//                         </button>
//                         <button
//                             className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "}
//                             onClick={() => setToggleState(3)}
//                         >
//                             Work Anniversary
//                         </button>
//                         {/* <button
//                             className={toggleState === 4 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "}
//                             onClick={() => setToggleState(4)}
//                         >
//                             Important Message
//                         </button> */}
//                         <button
//                             className={toggleState === 5 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "}
//                             onClick={() => setToggleState(5)}
//                         >
//                             Event
//                         </button>
//                         <button
//                             className={toggleState === 6 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading  "}
//                             onClick={() => setToggleState(6)}
//                         >
//                             Star
//                         </button>
//                     </div>
//                 </div>
//                 {/* <hr className='jobdesk-subseaction-hr' /> */}
//                 <div className="content-tabs">
//                     {toggleState === 1 ? <Announcements /> : null}
//                     {toggleState === 2 ? <Birthday /> : null}
//                     {toggleState === 3 ? <Workanniversery /> : null}
//                     {toggleState === 4 ? <ImportantMessage /> : null}
//                     {toggleState === 5 ? <Event /> : null}
//                     {toggleState === 6 ? <Star /> : null}

//                 </div>

//             </div>
//         </div>
//     )
// }

// export default Informationcomponent

// ─── Announcements Tab ───────────────────────────────────────────────────────
const Announcements = () => {
    const [allannouncement, setAllannouncement] = useState([]);
    const [buffer, setBuffering] = useState(true);
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));

    const getAnnouncement = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL}/settings/infromtation/${toggleCompany}/`);
            setAllannouncement(res.data);
        } catch (err) {
            console.error(err.message);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => {
        getAnnouncement();
    }, [toggleCompany]);

    const createMarkup = (content) => {
        const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
        return {
            __html: content.replace(linkRegex, (url) =>
                `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
            ),
        };
    };

    const visibleAnnouncements = allannouncement.filter(
        (info) => info.start_visibility <= formattedDate && formattedDate <= info.end_visibility
    );

    if (buffer) return <Loader container={true} />;

    if (visibleAnnouncements.length === 0) {
        return (
            <div style={styles.emptyState}>
                <div style={styles.emptyIcon}>
                    {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M18 8h1a4 4 0 0 1 0 8h-1M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8zM6 1v3M10 1v3M14 1v3"
                            stroke="rgb(37,118,188)" strokeWidth="2" strokeLinecap="round" />
                    </svg> */}
                    <AnnouncementIllustration />
                </div>
                <div style={styles.emptyTitle}>No announcements at the moment</div>
                <div style={styles.emptySub}>We'll notify you when there's something important.</div>
            </div>
        );
    }

    return (
        <div style={styles.tabContent}>
            {visibleAnnouncements.map((data, index) => {
                const formattedDate = new Date(data.date).toLocaleString('en-US', {
                    month: 'long', day: 'numeric', year: 'numeric',
                });
                return (
                    <div key={index} style={styles.listItem}>
                        <div style={styles.listIcon}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M18 8h1a4 4 0 0 1 0 8h-1M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8zM6 1v3M10 1v3M14 1v3"
                                    stroke="rgb(37,118,188)" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                        </div>
                        <div style={styles.listBody}>
                            <div style={styles.listTitle}>{index + 1}. {data.title}</div>
                            <div style={styles.listDate}>
                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
                                    <path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                                {formattedDate}
                            </div>
                            <div style={styles.listDesc}>
                                <div dangerouslySetInnerHTML={createMarkup(data.description)} />
                            </div>
                            {data.file && (
                                <a href={data.file} target="_blank" rel="noreferrer" style={{ marginTop: '6px', display: 'inline-block' }}>
                                    <AttachmentIcon source={data.file} />
                                </a>
                            )}
                        </div>
                    </div>
                );
            })}
        </div>
    );
};


// ─── Birthday Tab ─────────────────────────────────────────────────────────────
const Birthday = () => {
    const [todayBirthdays, setTodayBirthdays] = useState([]);
    const [thisWeekBirthdays, setThisWeekBirthdays] = useState([]);
    const [thisMonthBirthdays, setThisMonthBirthdays] = useState([]);
    const [buffer, setBuffering] = useState(true);

    const getBirthdayData = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL}/settings/birthday/`);
            filterBirthdays(res.data);
        } catch (err) {
            console.error(err.message);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => { getBirthdayData(); }, []);

    const filterBirthdays = (data) => {
        const today = new Date();
        const thisWeekEnd = new Date();
        thisWeekEnd.setDate(today.getDate() + 7);

        setTodayBirthdays(data.filter((item) => {
            const dob = new Date(item.dob);
            return dob.getDate() === today.getDate() && dob.getMonth() === today.getMonth();
        }));
        setThisWeekBirthdays(data.filter((item) => {
            const dob = new Date(item.dob);
            const dobThisYear = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());
            return dobThisYear >= today && dobThisYear <= thisWeekEnd;
        }));
        setThisMonthBirthdays(data.filter((item) => {
            const dob = new Date(item.dob);
            const dobThisYear = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());
            return dobThisYear > thisWeekEnd && dob.getMonth() === today.getMonth();
        }));
    };

    if (buffer) return <Loader container={true} />;

    const allEmpty = todayBirthdays.length === 0 && thisWeekBirthdays.length === 0 && thisMonthBirthdays.length === 0;
    if (allEmpty) {
        return (
            <div style={styles.emptyState}>
                <div style={styles.emptyIcon}>
                    <BirthdayIcon size={140} />
                </div>
                <div style={styles.emptyTitle}>No upcoming birthdays</div>
                <div style={styles.emptySub}>Check back soon for celebrations.</div>
            </div>
        );
    }

    const PersonCard = ({ data, badgeLabel, badgeStyle }) => {
        const formattedDob = new Date(data.dob).toLocaleString('en-US', { month: 'short', day: 'numeric' });
        const initials = data.name?.split(' ').map(p => p[0]).join('').slice(0, 2).toUpperCase();
        return (
            <div style={styles.personCard}>
                <div style={styles.avatarWrap}>
                    {data.profilepic
                        ? <CustomImageModal customStyle><img src={`${IMAGE_URL}${data.profilepic}`} alt="profile" style={styles.avatarImg} /></CustomImageModal>
                        : <div style={styles.avatarInitials}>{initials}</div>
                    }
                </div>
                <div style={styles.personInfo}>
                    <div style={styles.personName}>{data.name}</div>
                    <div style={styles.personMeta}>
                        <span style={styles.metaTag}>
                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                <path d="M7.5 7H10.25M7.5 11H10.25M7.5 15H10.25M13.75 7H16.5M13.75 11H16.5M13.75 15H16.5M20 21V6.2C20 5.08 20 4.52 19.78 4.09 19.59 3.72 19.28 3.41 18.91 3.22 18.48 3 17.92 3 16.8 3H7.2C6.08 3 5.52 3 5.09 3.22 4.72 3.41 4.41 3.72 4.22 4.09 4 4.52 4 5.08 4 6.2V21M22 21H2"
                                    stroke="#64748b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            {data.division_name}
                        </span>
                        <span style={styles.metaTag}>
                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                <path d="M16 7C16 6.07 16 5.6 15.9 5.22 15.62 4.19 14.81 3.38 13.78 3.1 13.4 3 12.93 3 12 3c-.93 0-1.4 0-1.78.1C9.19 3.38 8.38 4.19 8.1 5.22 8 5.6 8 6.07 8 7M5.2 21h13.6c1.12 0 1.68 0 2.1-.22.38-.19.69-.49.88-.88C22 19.48 22 18.92 22 17.8V10.2c0-1.12 0-1.68-.22-2.1a2 2 0 0 0-.88-.88C20.48 7 19.92 7 18.8 7H5.2c-1.12 0-1.68 0-2.1.22a2 2 0 0 0-.88.88C2 8.52 2 9.08 2 10.2v7.6c0 1.12 0 1.68.22 2.1.19.38.49.69.88.88C3.52 21 4.08 21 5.2 21z"
                                    stroke="#64748b" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                            {data.department_name}
                        </span>

                    </div>
                </div>
                <span style={{ ...styles.badge, ...badgeStyle, gap: '4px', ...styles.metaTag }} className="d-flex align-center">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="4" width="18" height="18" rx="2" stroke="#64748b" strokeWidth="2" />
                        <path d="M16 2v4M8 2v4M3 10h18" stroke="#64748b" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    {formattedDob}
                </span>
                {/* <span style={{ ...styles.badge, ...badgeStyle }}>{badgeLabel}</span> */}
            </div>
        );
    };

    return (

        <div style={styles.tabContent}>
            {todayBirthdays.length > 0 && (<>
                <div style={styles.sectionLabel}>Birthdays today</div>
                {todayBirthdays.map((data, i) => <PersonCard key={i} data={data} badgeLabel="Today" badgeStyle={styles.badgeToday} />)}
            </>)}
            {thisWeekBirthdays.length > 0 && (<>
                <div style={styles.sectionLabel}>Birthdays this week</div>
                {thisWeekBirthdays.map((data, i) => <PersonCard key={i} data={data} badgeLabel="This week" badgeStyle={styles.badgeWeek} />)}
            </>)}
            {thisMonthBirthdays.length > 0 && (<>
                <div style={styles.sectionLabel}>Birthdays this month</div>
                {thisMonthBirthdays.map((data, i) => <PersonCard key={i} data={data} badgeLabel="This month" badgeStyle={styles.badgeMonth} />)}
            </>)}
        </div>
    );
};


// ─── Work Anniversary Tab ─────────────────────────────────────────────────────
const Workanniversery = () => {
    const [todayAnniversaries, setTodayAnniversaries] = useState([]);
    const [thisWeekAnniversaries, setThisWeekAnniversaries] = useState([]);
    const [thisMonthAnniversaries, setThisMonthAnniversaries] = useState([]);
    const [buffer, setBuffering] = useState(true);

    const getBirthdayData = async () => {
        setBuffering(true);
        try {
            const res = await axios.get(`${BASE_URL}/settings/workaniversary/`);
            filterWorkanniversery(res.data);
        } catch (err) {
            console.error(err.message);
        } finally {
            setBuffering(false);
        }
    };

    useEffect(() => { getBirthdayData(); }, []);

    const filterWorkanniversery = (data) => {
        const today = new Date();
        const thisWeekEnd = new Date();
        thisWeekEnd.setDate(today.getDate() + 7);

        setTodayAnniversaries(data.filter((item) => {
            const d = new Date(item.joining_date);
            return d.getDate() === today.getDate() && d.getMonth() === today.getMonth();
        }));
        setThisWeekAnniversaries(data.filter((item) => {
            const d = new Date(item.joining_date);
            const ann = new Date(today.getFullYear(), d.getMonth(), d.getDate());
            return ann >= today && ann <= thisWeekEnd;
        }));
        setThisMonthAnniversaries(data.filter((item) => {
            const d = new Date(item.joining_date);
            const ann = new Date(today.getFullYear(), d.getMonth(), d.getDate());
            return ann > thisWeekEnd && d.getMonth() === today.getMonth();
        }));
    };

    const calculateAnniversary = (anniversaryDate) => {
        return new Date().getFullYear() - new Date(anniversaryDate).getFullYear();
    };

    if (buffer) return <Loader container={true} />;

    const allEmpty = todayAnniversaries.length === 0 && thisWeekAnniversaries.length === 0 && thisMonthAnniversaries.length === 0;
    if (allEmpty) {
        return (
            <div style={styles.emptyState}>
                <div style={styles.emptyIcon}>
                    <WorkAnniversary />
                </div>
                <div style={styles.emptyTitle}>No upcoming anniversaries</div>
                <div style={styles.emptySub}>Work anniversaries will appear here.</div>
            </div>
        );
    }

    const AnnCard = ({ data, badgeLabel, badgeStyle }) => {
        const yrs = calculateAnniversary(data.joining_date);
        const initials = data.name?.split(' ').map(p => p[0]).join('').slice(0, 2).toUpperCase();
        return (
            <div style={styles.personCard}>
                <div style={styles.avatarWrap}>
                    {data.profilepic
                        ? <CustomImageModal customStyle><img src={`${IMAGE_URL}${data.profilepic}`} alt="profile" style={styles.avatarImg} /></CustomImageModal>
                        : <div style={styles.avatarInitials}>{initials}</div>
                    }
                </div>
                <div style={styles.personInfo}>
                    <div style={styles.personName}>{data.name}</div>
                    <div style={styles.personMeta}>
                        <span style={styles.metaTag}>
                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                <path d="M7.5 7H10.25M7.5 11H10.25M7.5 15H10.25M13.75 7H16.5M13.75 11H16.5M13.75 15H16.5M20 21V6.2C20 5.08 20 4.52 19.78 4.09 19.59 3.72 19.28 3.41 18.91 3.22 18.48 3 17.92 3 16.8 3H7.2C6.08 3 5.52 3 5.09 3.22 4.72 3.41 4.41 3.72 4.22 4.09 4 4.52 4 5.08 4 6.2V21M22 21H2"
                                    stroke="#64748b" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                            {data.division_name}
                        </span>
                        <span style={styles.metaTag}>
                            <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                <path d="M16 7C16 6.07 16 5.6 15.9 5.22 15.62 4.19 14.81 3.38 13.78 3.1 13.4 3 12.93 3 12 3c-.93 0-1.4 0-1.78.1C9.19 3.38 8.38 4.19 8.1 5.22 8 5.6 8 6.07 8 7M5.2 21h13.6c1.12 0 1.68 0 2.1-.22.38-.19.69-.49.88-.88C22 19.48 22 18.92 22 17.8V10.2c0-1.12 0-1.68-.22-2.1a2 2 0 0 0-.88-.88C20.48 7 19.92 7 18.8 7H5.2c-1.12 0-1.68 0-2.1.22a2 2 0 0 0-.88.88C2 8.52 2 9.08 2 10.2v7.6c0 1.12 0 1.68.22 2.1.19.38.49.69.88.88C3.52 21 4.08 21 5.2 21z"
                                    stroke="#64748b" strokeWidth="2" strokeLinecap="round" />
                            </svg>
                            {data.department_name}
                        </span>

                    </div>
                </div>
                {/* <span style={{ ...styles.badge, ...badgeStyle }}>{badgeLabel}</span> */}
                <span style={{ ...styles.badge, ...badgeStyle, gap: '4px', ...styles.metaTag }} className="d-flex align-center text-black-color">
                    <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 21 12 17.27 5.82 21 7 14.14 2 9.27l6.91-1.01L12 2z"
                            stroke="#64748b" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                    {yrs} yrs
                </span>
            </div>
        );
    };

    return (

        <div style={styles.tabContent}>
            {todayAnniversaries.length > 0 && (<>
                <div style={styles.sectionLabel}>Anniversaries today</div>
                {todayAnniversaries.map((data, i) => <AnnCard key={i} data={data} badgeLabel="Today" badgeStyle={styles.badgeToday} />)}
            </>)}
            {thisWeekAnniversaries.length > 0 && (<>
                <div style={styles.sectionLabel}>Anniversaries this week</div>
                {thisWeekAnniversaries.map((data, i) => <AnnCard key={i} data={data} badgeLabel="This week" badgeStyle={styles.badgeWeek} />)}
            </>)}
            {thisMonthAnniversaries.length > 0 && (<>
                <div style={styles.sectionLabel}>Anniversaries this month</div>
                {thisMonthAnniversaries.map((data, i) => <AnnCard key={i} data={data} badgeLabel="This month" badgeStyle={styles.badgeMonth} />)}
            </>)}
        </div>
    );
};


// ─── Important Message Tab ────────────────────────────────────────────────────
const ImportantMessage = () => {
    const [message, setImpoMessage] = useState([]);

    useEffect(() => {
        const getImportantInfoData = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/settings/importantnotificationAPI/`);
                setImpoMessage(res.data);
            } catch (err) {
                console.error(err.message);
            }
        };
        getImportantInfoData();
    }, []);

    const createMarkup = (content) => {
        const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
        return {
            __html: content.replace(linkRegex, (url) =>
                `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
            ),
        };
    };

    if (message.length === 0) {
        return (
            <div style={styles.emptyState}>
                <div style={styles.emptyIcon}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                            stroke="rgb(37,118,188)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div style={styles.emptyTitle}>No important messages</div>
                <div style={styles.emptySub}>Important notifications will appear here.</div>
            </div>
        );
    }

    return (
        <div style={styles.tabContent}>
            {message.map((data, index) => {
                const formattedDate = new Date(data.date).toLocaleString('en-US', {
                    month: 'short', day: 'numeric', year: 'numeric',
                });
                return (
                    <div key={index} style={styles.listItem}>
                        <div style={styles.listIcon}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                                <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"
                                    stroke="rgb(37,118,188)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </div>
                        <div style={styles.listBody}>
                            <div style={styles.listDesc}>
                                <div dangerouslySetInnerHTML={createMarkup((index + 1) + '. ' + data.message)} />
                            </div>
                            <div style={styles.listDate}>
                                <svg width="10" height="10" viewBox="0 0 24 24" fill="none">
                                    <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
                                    <path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                                </svg>
                                {formattedDate}
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};


// ─── Event Tab ────────────────────────────────────────────────────────────────
const Event = () => {
    const [event, setEvent] = useState([]);
    const [buffer, setBuffering] = useState(true);
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));

    useEffect(() => {
        const getEventData = async () => {
            setBuffering(true);
            try {
                const res = await axios.get(`${BASE_URL}/settings/event-filter/${toggleCompany}/`);
                setEvent(res.data);
            } catch (err) {
                console.error(err.message);
            } finally {
                setBuffering(false);
            }
        };
        getEventData();
    }, [toggleCompany]);

    const createMarkup = (content) => {
        const linkRegex = /(?:https?|ftp):\/\/[^\s]+/g;
        return {
            __html: content.replace(linkRegex, (url) =>
                `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`
            ),
        };
    };

    if (buffer) return <Loader container={true} />;

    if (event.length === 0) {
        return (
            <div style={styles.emptyState}>
                <div style={styles.emptyIcon}>
                    <svg width="70" height="70" viewBox="0 0 24 24" fill="none">
                        <rect x="3" y="4" width="18" height="18" rx="2" stroke="rgb(37,118,188)" strokeWidth="2" />
                        <path d="M16 2v4M8 2v4M3 10h18" stroke="rgb(37,118,188)" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </div>
                <div style={styles.emptyTitle}>No upcoming events</div>
                <div style={styles.emptySub}>Events will appear here when scheduled.</div>
            </div>
        );
    }

    return (
        <div style={styles.tabContent}>
            {event.map((data, index) => {
                const dateObj = new Date(data.date);
                const day = dateObj.toLocaleString('en-US', { day: 'numeric' });
                const month = dateObj.toLocaleString('en-US', { month: 'short' });
                const fullDate = dateObj.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

                return (
                    <div key={index} style={styles.eventItem}>
                        {/* date box */}
                        <div style={styles.eventDateBox}>
                            <div style={styles.eventDay}>{day}</div>
                            <div style={styles.eventMonth}>{month.toUpperCase()}</div>
                        </div>

                        {/* event image if exists */}
                        {data.file && (
                            <CustomImageModal customStyle>
                                <img src={data.file} alt={data.title} style={styles.eventImg} />
                            </CustomImageModal>
                        )}

                        <div style={styles.listBody}>
                            <div style={styles.listDate}>{fullDate}</div>
                            <div style={styles.listTitle}>{data.title}</div>
                            <div style={styles.listDesc}>
                                <div dangerouslySetInnerHTML={createMarkup(data.description)} />
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};


// ─── Star Tab ─────────────────────────────────────────────────────────────────
const Star = () => {
    const [star, setStar] = useState([]);
    const [buffer, setBuffering] = useState(true);
    const [toggleCompany, setToggleCompany] = useState(sessionStorage.getItem('company_id'));

    useEffect(() => {
        setBuffering(true);
        const getStarData = async () => {
            try {
                const res = await axios.get(`${BASE_URL}/wfm/performance-by-filter/${toggleCompany}/`);
                setStar(res.data);
            } catch (err) {
                console.error(err.message);
            } finally {
                setBuffering(false);
            }
        };
        getStarData();
    }, [toggleCompany]);

    if (buffer) return <Loader container={true} />;

    if (star.length === 0) {
        return (
            <div style={styles.emptyState}>
                <div style={styles.emptyIcon}>
                    <StarTrophyIllustration />
                </div>
                <div style={styles.emptyTitle}>No recognitions yet</div>
                <div style={styles.emptySub}>Star performers will be celebrated here.</div>
            </div>
        );
    }

    return (
        <div style={styles.tabContent}>
            {star.map((data, index) => {
                const initials = data.name?.split(' ').map(p => p[0]).join('').slice(0, 2).toUpperCase();
                return (
                    <div key={index} style={styles.starItem}>
                        <div style={styles.avatarWrap}>
                            {data.profilepic
                                ? <CustomImageModal customStyle>
                                    <img src={`${IMAGE_URL}${data.profilepic}`} alt="profile" style={{ ...styles.avatarImg, border: '2px solid rgb(216,233,255)' }} />
                                </CustomImageModal>
                                : <div style={styles.avatarInitials}>{initials}</div>
                            }
                        </div>
                        <div style={styles.personInfo}>
                            <div style={styles.personName}>{data.name}</div>
                            <div style={styles.starReason}>
                                <strong style={{ fontWeight: 500 }}>{data.title}</strong> awarded by {data.recognized_by}
                            </div>
                            <div style={{ ...styles.starReason, marginTop: '2px' }}>
                                For: {data.reason_for_recogntion}
                            </div>
                        </div>
                        {data.image_reward && (
                            <CustomImageModal customStyle>
                                <img src={data.image_reward} alt="Badge" style={styles.rewardBadge} />
                            </CustomImageModal>
                        )}
                    </div>
                );
            })}
        </div>
    );
};


// ─── Shared Styles ────────────────────────────────────────────────────────────
const styles = {
    tabContent: {
        display: 'flex', flexDirection: 'column', gap: '8px',
        maxHeight: '300px', overflowY: 'auto', padding: '2px 0',
    },
    // list item (announcements / important message)
    listItem: {
        display: 'flex', gap: '10px', padding: '12px',
        border: '1px solid #eef0f5', borderRadius: '10px', background: '#f9fbff',
    },
    listIcon: {
        width: '32px', height: '32px', borderRadius: '8px',
        background: 'rgb(216,233,255)', display: 'flex',
        alignItems: 'center', justifyContent: 'center', flexShrink: 0, marginTop: '1px',
    },
    listBody: { flex: 1, minWidth: 0 },
    listTitle: { fontSize: '13px', fontWeight: 600, color: '#1e293b', marginBottom: '4px' },
    listDate: {
        display: 'flex', alignItems: 'center', gap: '4px',
        fontSize: '11px', color: '#94a3b8', marginBottom: '4px',
    },
    listDesc: { fontSize: '12px', color: '#64748b', lineHeight: 1.5 },

    // person card (birthday / anniversary)
    personCard: {
        display: 'flex', alignItems: 'center', gap: '10px',
        padding: '10px 12px', border: '1px solid #eef0f5',
        borderRadius: '10px', background: '#f9fbff',
    },
    avatarWrap: { flexShrink: 0 },
    avatarImg: { width: '38px', height: '38px', borderRadius: '50%', objectFit: 'cover' },
    avatarInitials: {
        width: '38px', height: '38px', borderRadius: '50%',
        background: 'rgb(216,233,255)', display: 'flex',
        alignItems: 'center', justifyContent: 'center',
        fontSize: '13px', fontWeight: 600, color: 'rgb(37,118,188)',
    },
    personInfo: { flex: 1, minWidth: 0 },
    personName: { fontSize: '13px', fontWeight: 600, color: '#1e293b', marginBottom: '4px' },
    personMeta: { display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' },
    metaTag: {
        display: 'flex', alignItems: 'center', gap: '3px',
        fontSize: '11px', color: '#2c2c2c',
    },

    // badges
    badge: {
        fontSize: '10px', fontWeight: 600, padding: '3px 8px',
        borderRadius: '20px', flexShrink: 0, whiteSpace: 'nowrap',
    },
    badgeToday: { background: 'rgb(216,233,255)', color: 'rgb(37,118,188)' },
    badgeWeek: { background: '#e8f5e9', color: '#16a34a' },
    badgeMonth: { background: '#fff3e0', color: '#ea580c' },

    // section label
    sectionLabel: {
        fontSize: '11px', fontWeight: 600, color: '#94a3b8',
        textTransform: 'uppercase', letterSpacing: '0.5px',
        padding: '4px 0 2px',
    },

    // event
    eventItem: {
        display: 'flex', gap: '10px', alignItems: 'flex-start',
        padding: '12px', border: '1px solid #eef0f5',
        borderRadius: '10px', background: '#f9fbff',
    },
    eventDateBox: {
        width: '40px', height: '44px', borderRadius: '8px',
        background: 'rgb(216,233,255)', display: 'flex',
        flexDirection: 'column', alignItems: 'center',
        justifyContent: 'center', flexShrink: 0,
    },
    eventDay: { fontSize: '16px', fontWeight: 700, color: 'rgb(37,118,188)', lineHeight: 1 },
    eventMonth: { fontSize: '9px', fontWeight: 600, color: 'rgb(37,118,188)', textTransform: 'uppercase' },
    eventImg: { width: '48px', height: '48px', borderRadius: '8px', objectFit: 'cover', flexShrink: 0 },

    // star
    starItem: {
        display: 'flex', alignItems: 'center', gap: '10px',
        padding: '12px', border: '1px solid #eef0f5',
        borderRadius: '10px', background: '#f9fbff',
    },
    starReason: { fontSize: '12px', color: '#64748b', lineHeight: 1.4 },
    rewardBadge: { width: '40px', height: '40px', objectFit: 'contain', flexShrink: 0 },

    // empty state
    emptyState: {
        display: 'flex', flexDirection: 'column',
        alignItems: 'center', justifyContent: 'center',
        padding: '32px 16px', gap: '8px',
    },
    emptyIcon: {
        borderRadius: '50%',
        // background: 'rgb(216,233,255)',
        display: 'flex',
        alignItems: 'center', justifyContent: 'center',
    },
    emptyTitle: { fontSize: '13px', fontWeight: 600, color: '#1e293b' },
    emptySub: { fontSize: '12px', color: '#94a3b8', textAlign: 'center' },
};


// ─── Main Informationcomponent ────────────────────────────────────────────────
const TABS = [
    {
        id: 1, label: 'Announcements',
        icon:
            <svg xmlns="http://www.w3.org/2000/svg" width="2em" height="2em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M18 8a3 3 0 0 1 0 6" />
                <path d="M10 8v11a1 1 0 0 1 -1 1h-1a1 1 0 0 1 -1 -1v-5" />
                <path d="M12 8l4.524 -3.77a.9 .9 0 0 1 1.476 .692v12.156a.9 .9 0 0 1 -1.476 .692l-4.524 -3.77h-8a1 1 0 0 1 -1 -1v-4a1 1 0 0 1 1 -1h8" />
            </svg>
    },
    {
        id: 2, label: 'Birthday',
        icon: <CelebrationIcon />
    },
    {
        id: 3, label: 'Work Anniversary',
        icon: <OfficeBagIcon size={20} color="#64748b" />
    },
    {
        id: 5, label: 'Event',
        icon: <svg width="12" height="12" viewBox="0 0 24 24" fill="none" style={{ display: 'inline', verticalAlign: '-1px', marginRight: '4px' }}>
            <rect x="3" y="4" width="18" height="18" rx="2" stroke="currentColor" strokeWidth="2" />
            <path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
        </svg>
    },
    {
        id: 6, label: 'Star',
        icon: <TrophyIconWithoutIllustration size={20} color="#64748b" />
    },
];

const Informationcomponent = () => {
    const [toggleState, setToggleState] = useState(1);

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 0 }}>
            {/* Tab buttons */}
            {/* <div style={{
                display: 'flex', gap: '4px', padding: '10px 0 0',
                overflowX: 'auto',
                scrollbarWidth: 'none',
                width: '100%',
            }}> */}
            <div className="tabs-container">
                {TABS.map(tab => (
                    <button
                        key={tab.id}
                        onClick={() => setToggleState(tab.id)}
                        // style={{
                        //     display: 'flex', alignItems: 'center',
                        //     padding: '7px 11px', fontSize: '12px', fontWeight: 500,
                        //     border: 'none', cursor: 'pointer', whiteSpace: 'nowrap',
                        //     borderRadius: '6px 6px 0 0',
                        //     background: toggleState === tab.id ? 'rgb(216,233,255)' : 'transparent',
                        //     color: toggleState === tab.id ? 'rgb(37,118,188)' : '#64748b',
                        //     borderBottom: toggleState === tab.id ? '2px solid rgb(37,118,188)' : '2px solid transparent',
                        //     transition: 'all 0.15s',
                        //     position: 'relative', bottom: '-1px',
                        // }}
                        className={`tab-btn ${toggleState === tab.id ? 'tab-btn-active' : ''
                            }`}
                    // style={{
                    //     display: 'flex', alignItems: 'center', justifyContent: 'center',
                    //     flex: 1,
                    //     minWidth: 0,
                    //     padding: '7px 6px', fontSize: '12px', fontWeight: 500,
                    //     border: 'none', cursor: 'pointer',
                    //     // whiteSpace: 'nowrap',
                    //     borderRadius: '6px 6px 0 0',
                    //     background: toggleState === tab.id ? 'rgb(216,233,255)' : 'rgb(241,247,255)',
                    //     color: toggleState === tab.id ? 'rgb(37,118,188)' : '#64748b',
                    //     borderBottom: toggleState === tab.id ? '2px solid rgb(37,118,188)' : '2px solid #d1e0f0',
                    //     transition: 'all 0.15s',
                    //     position: 'relative', bottom: '-1px',
                    //     overflow: 'hidden',
                    //     textOverflow: 'ellipsis',
                    //     gap: '3px'
                    // }}
                    >
                        {tab.icon}
                        {tab.label}
                    </button>
                ))}
            </div>

            {/* Tab content */}
            <div style={{ padding: '12px 0 0' }}>
                {toggleState === 1 && <Announcements />}
                {toggleState === 2 && <Birthday />}
                {toggleState === 3 && <Workanniversery />}
                {toggleState === 4 && <ImportantMessage />}
                {toggleState === 5 && <Event />}
                {toggleState === 6 && <Star />}
            </div>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false}
                newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </div>
    );
};

export default Informationcomponent;



